const INVALID_TIMEZONE_LABELS = new Set([
  'Time zone not found',
  'Time Zone Not Specified'
]);

export const isValidTimeZone = (
  value: string | null | undefined
): value is string => {
  if (!value || typeof value !== 'string') {
    return false;
  }

  const timeZone = value.trim();
  if (!timeZone || INVALID_TIMEZONE_LABELS.has(timeZone)) {
    return false;
  }

  try {
    new Intl.DateTimeFormat('en-US', { timeZone });
    return true;
  } catch {
    return false;
  }
};

export const resolvePreferredTimeZone = (
  ...candidates: Array<string | null | undefined>
) => {
  return candidates.find(isValidTimeZone);
};

type TimelineTimeZoneCandidates = {
  caseRunTimeZone?: string | null;
  activeCaseRunTimeZone?: string | null;
  organizationTimeZone?: string | null;
};

export const resolveTimelineTimeZone = ({
  caseRunTimeZone,
  activeCaseRunTimeZone,
  organizationTimeZone
}: TimelineTimeZoneCandidates) => {
  return resolvePreferredTimeZone(
    caseRunTimeZone,
    activeCaseRunTimeZone,
    organizationTimeZone
  );
};
